export const chatData = {
  en: {
    start: {
      message:
        "Welcome to Connected Group! 🚀 As your trusted partner in Digital Transformation across Asia, we are dedicated to elevating your business with cutting-edge tech solutions. How can we assist you today?",
      options: [
        { label: " Services", next: "services" },
        { label: " Products", next: "products" },
        { label: " AI Solutions", next: "ai_services" },
        { label: " Communication & API", next: "communication" },
        { label: " About Us", next: "about" },
        { label: " Partners", next: "partners" },
        { label: " Locations", next: "locations" },
        { label: " Clients", next: "clients" },
        { label: " Careers", next: "careers" },
      ],
    },

    services: {
      message:
        "We provide comprehensive and integrated ICT solutions. Select a category:",
      options: [
        { label: "Website Dev", next: "s_web" },
        { label: "App Dev", next: "s_app" },
        { label: "E-commerce Dev", next: "s_ecom" },
        { label: "Fintech & Payments", next: "s_fintech" },
        { label: "Cloud & Virtualization", next: "s_cloud" },
        { label: "System Integration", next: "s_si" },
        { label: "Back", next: "start" },
      ],
    },

    s_web: {
      message:
        "Custom Website Development including static, dynamic, CMS, and responsive web applications.",
      options: [
        { label: "Tech Stack", next: "tech_stack" },
        { label: "Back", next: "services" },
      ],
    },

    s_app: {
      message:
        "Application development tailored to web, mobile (iOS, Android), and desktop platforms.",
      options: [
        { label: "Tech Stack", next: "tech_stack" },
        { label: "Back", next: "services" },
      ],
    },

    s_ecom: {
      message:
        "End-to-end B2B and B2C E-commerce development with payment integration, inventory management, and analytics.",
      options: [{ label: "Back", next: "services" }],
    },

    s_fintech: {
      message:
        "Robust Fintech solutions including Mobile Wallet App development, direct banking integrations, payment gateways, and merchant account setups.",
      options: [{ label: "Back", next: "services" }],
    },

    tech_stack: {
      message:
        "Frontend: HTML, CSS, JS, jQuery, React, Tailwind\nBackend: NodeJs, MongoDB, PHP (Laravel, Codeigniter), MySQL\nMobile: Flutter, Native\nRealtime: WebRTC, WebSocket, Firebase\nInfra: AWS, Huawei Cloud, Redis, Cloudflare, Synology NAS",
      options: [{ label: "Back", next: "services" }],
    },

    s_cloud: {
      message:
        "Cloud Managed Services & Data Center Virtualization (VMWare, Mac Mini clusters) powered by certified DevOps Engineers.",
      options: [{ label: "Back", next: "services" }],
    },

    s_si: {
      message:
        "System Integration (SI) connecting disparate IT systems and applications to function cohesively.",
      options: [{ label: "Back", next: "services" }],
    },

    products: {
      message: "Explore our enterprise product portfolio:",
      options: [
        { label: " Mobile Wallet", next: "prod_wallet" },
        { label: " LMS", next: "prod_lms" },
        { label: " Property System", next: "prod_pms" },
        { label: " POS", next: "prod_pos" },
        { label: " ERP/CRM", next: "prod_erp" },
        { label: " Clinic System", next: "prod_clinic" },
        { label: " Hotel System", next: "prod_hotel" },
        { label: " Mortgage System", next: "prod_mortgage" },
        { label: "Back", next: "start" },
      ],
    },

    prod_wallet: {
      message:
        "Enterprise-level Mobile Wallet ecosystem featuring User Apps (KYC, top-ups) and Agent Apps (cash-in/out, commission tracking).",
      options: [{ label: "Back", next: "products" }],
    },

    prod_lms: {
      message:
        "Learning Management System with modules for student records, finance, HR attendance, payroll, examinations, and library management.",
      options: [{ label: "Back", next: "products" }],
    },

    prod_pms: {
      message:
        "Property Management System for tracking rent payments, bookings, and automated reminders for lease expirations.",
      options: [{ label: "Back", next: "products" }],
    },

    prod_pos: {
      message:
        "Cloud-based Point of Sale (POS) supporting multiple payment methods with real-time remote data access.",
      options: [{ label: "Back", next: "products" }],
    },

    prod_erp: {
      message:
        "ERP/CRM system with contact management, sales tracking, HR modules, billing, and robust reporting analytics.",
      options: [{ label: "Back", next: "products" }],
    },

    prod_clinic: {
      message:
        "Clinic Management System centralizing patient data, appointments, billing, invoicing, and staff scheduling.",
      options: [{ label: "Back", next: "products" }],
    },

    prod_hotel: {
      message:
        "Hotel Management System handling reservations, front desk operations, check-ins/outs, and loyalty programs.",
      options: [{ label: "Back", next: "products" }],
    },

    prod_mortgage: {
      message:
        "Mortgage Management System featuring automated loan application processing, credit checks, and real-time status tracking.",
      options: [{ label: "Back", next: "products" }],
    },

    ai_services: {
      message: "AI Integration & Fine-tuning services:",
      options: [
        { label: "AI Integration", next: "ai_integration" },
        { label: "Fine-Tuning", next: "ai_finetune" },
        { label: "Back", next: "start" },
      ],
    },

    ai_integration: {
      message:
        "Embedding pre-trained AI models (NLP, Computer Vision) into applications for tasks like chatbots, speech recognition, and predictions.",
      options: [{ label: "Back", next: "ai_services" }],
    },

    ai_finetune: {
      message:
        "Further training pre-trained models on specific datasets to optimize performance and improve accuracy within a particular domain.",
      options: [{ label: "Back", next: "ai_services" }],
    },

    communication: {
      message: "Reliable communication, top-up, and gateway solutions:",
      options: [
        { label: "Cloud PBX", next: "pbx" },
        { label: "SMS Gateway", next: "sms" },
        { label: "Payment Gateway", next: "payment" },
        { label: "Top-up Gateway", next: "topup" },
        { label: "Marketing Tools", next: "marketing" },
        { label: "Back", next: "start" },
      ],
    },

    pbx: {
      message:
        "Virtual Cloud PBX system allowing scalable, cost-effective management of internal and external calls without traditional hardware.",
      options: [{ label: "Back", next: "communication" }],
    },

    sms: {
      message:
        "SMS gateway acting as a bridge between platforms, allowing for two-way messaging, sender ID customization, and keyword processing.",
      options: [{ label: "Back", next: "communication" }],
    },

    payment: {
      message:
        "Secure payment gateway seamlessly connecting websites to payment processors with data encryption.",
      options: [{ label: "Back", next: "communication" }],
    },

    topup: {
      message:
        "API-driven Top-up Gateway processing real-time mobile airtime recharges (E-Load and E-Pin) for all major operators in Myanmar.",
      options: [{ label: "Back", next: "communication" }],
    },

    marketing: {
      message:
        "Marketing Tools to create, schedule, and manage campaigns and transactional messages via SMS and email.",
      options: [{ label: "Back", next: "communication" }],
    },

    about: {
      message:
        "With over 7 years of experience, Connected Group is leading Myanmar's Digital Transformation, driven by a team of experienced young professionals. We are expanding our operations beyond the ICT sector into education and other fields.",
      options: [
        { label: "Mission", next: "mission" },
        { label: "Vision", next: "vision" },
        { label: "Back", next: "start" },
      ],
    },

    mission: {
      message:
        "To be a Successful Digital Transformation Company by being a reliable, innovative, and user-friendly software service provider.",
      options: [{ label: "Back", next: "about" }],
    },

    vision: {
      message:
        "Connected Group is at the core of the Digital Solutions and Transformation ecosystem and will remain a strong player with a strong technology backbone.",
      options: [{ label: "Back", next: "about" }],
    },

    partners: {
      message:
        "We partner with leading global technology providers. We also warmly welcome new partners! If you are interested in partnering with us, please email partner@cbs.com.mm.",
      options: [{ label: "Back", next: "start" }],
    },

    clients: {
      message: "We serve both Public and Private sectors.",
      options: [
        { label: "Public", next: "c_public" },
        { label: "Private", next: "c_private" },
        { label: "Back", next: "start" },
      ],
    },

    c_public: {
      message:
        "Trusted by various government organizations and top educational institutions.",
      options: [{ label: "Back", next: "clients" }],
    },

    c_private: {
      message: "Serving a range of dynamic private enterprises.",
      options: [{ label: "Back", next: "clients" }],
    },

    locations: {
      message: "We actively operate across Asia.",
      options: [
        { label: "Contact Info", next: "contact" },
        { label: "Back", next: "start" },
      ],
    },

    contact: {
      message: "Phone: +959 787 663 799\nEmail: info@connected.com.mm",
      options: [{ label: "Back", next: "start" }],
    },

    careers: {
      message:
        "We combine young talent and experienced professionals. To apply, please submit your CV via this link: https://forms.gle/nPdXqbjJXKXV7xon7 or email us at hr@cbs.com.mm. We will consider your application when suitable vacant positions become available.",
      options: [{ label: "Back", next: "start" }],
    },
  },

  mm: {
    start: {
      message:
        "Connected Group မှ နွေးထွေးစွာ ကြိုဆိုပါတယ်။ 🚀 အာရှတိုက်တစ်လွှားရှိ လုပ်ငန်းများအတွက် ယုံကြည်စိတ်ချရသော Digital Transformation မိတ်ဖက်အဖြစ် ရပ်တည်နေပါတယ်။ လူကြီးမင်း၏ လုပ်ငန်းကို နည်းပညာဖြင့် အဆင့်မြှင့်တင်ရန် ယနေ့ ဘာများကူညီပေးရမလဲ။",
      options: [
        { label: " ဝန်ဆောင်မှုများ", next: "services" },
        { label: " ထုတ်ကုန်များ", next: "products" },
        { label: " AI ဝန်ဆောင်မှု", next: "ai_services" },
        { label: " ဆက်သွယ်ရေးနှင့် APIs", next: "communication" },
        { label: " ကျွန်ုပ်တို့အကြောင်း", next: "about" },
        { label: " မိတ်ဖက်များ", next: "partners" },
        { label: " တည်နေရာများ", next: "locations" },
        { label: " ဖောက်သည်များ", next: "clients" },
        { label: " အလုပ်အကိုင်", next: "careers" },
      ],
    },

    services: {
      message:
        "လုပ်ငန်းသုံးအတွက် ပြီးပြည့်စုံသော ICT ဝန်ဆောင်မှုများကို ရွေးချယ်ပါ။",
      options: [
        { label: "Website ရေးသားခြင်း", next: "s_web" },
        { label: "App ရေးသားခြင်း", next: "s_app" },
        { label: "E-commerce", next: "s_ecom" },
        { label: "Fintech နှင့် Payments", next: "s_fintech" },
        { label: "Cloud နှင့် Virtualization", next: "s_cloud" },
        { label: "System Integration", next: "s_si" },
        { label: "နောက်သို့", next: "start" },
      ],
    },

    s_web: {
      message:
        "Static, Dynamic, CMS နှင့် Responsive ဖြစ်သော Web Application များကို လုပ်ငန်းလိုအပ်ချက်နှင့် ကိုက်ညီအောင် ဖန်တီးပေးပါသည်။",
      options: [
        { label: "Tech Stack", next: "tech_stack" },
        { label: "နောက်သို့", next: "services" },
      ],
    },

    s_app: {
      message:
        "Web, Mobile (iOS, Android) နှင့် Desktop Platform များအတွက် အရည်အသွေးမြင့် Application များ ရေးသားပေးပါသည်။",
      options: [
        { label: "Tech Stack", next: "tech_stack" },
        { label: "နောက်သို့", next: "services" },
      ],
    },

    s_ecom: {
      message:
        "Payment ချိတ်ဆက်မှု၊ Inventory စီမံခန့်ခွဲမှုများနှင့် B2B, B2C E-commerce System များကို အစအဆုံး တည်ဆောက်ပေးပါသည်။",
      options: [{ label: "နောက်သို့", next: "services" }],
    },

    s_fintech: {
      message:
        "Mobile Wallet App များရေးသားခြင်းနှင့် ဘဏ်များနှင့်ချိတ်ဆက်ထားသော Fintech Solutions များ (ဥပမာ- Payment Gateway စနစ်များ၊ Merchant Account လျှောက်ထားခြင်းနှင့် ချိတ်ဆက်ခြင်း)။",
      options: [{ label: "နောက်သို့", next: "services" }],
    },

    tech_stack: {
      message:
        "Frontend: HTML, CSS, JS, jQuery, React, Tailwind\nBackend: NodeJs, MongoDB, PHP (Laravel, Codeigniter), MySQL\nMobile: Flutter, Native\nRealtime: WebRTC, WebSocket, Firebase\nCloud: AWS, Huawei Cloud, Redis, Cloudflare, Synology NAS",
      options: [{ label: "နောက်သို့", next: "services" }],
    },

    s_cloud: {
      message:
        "AWS Certified DevOps Engineer များနှင့် VMWare Certified ပညာရှင်များမှ Cloud Managed Services နှင့် Data Center Virtualization (Mac Mini Clusters) များကို စီမံခန့်ခွဲပေးပါသည်။",
      options: [{ label: "နောက်သို့", next: "services" }],
    },

    s_si: {
      message:
        "System Integration ဝန်ဆောင်မှုဖြင့် မတူညီသော System များကို ချောမွေ့စွာ အလုပ်လုပ်နိုင်ရန် ချိတ်ဆက်ပေးပါသည်။",
      options: [{ label: "နောက်သို့", next: "services" }],
    },

    products: {
      message:
        "လုပ်ငန်းများတွင် ချက်ချင်းအသုံးပြုနိုင်မည့် အဆင့်မြင့် Software ထုတ်ကုန်များ:",
      options: [
        { label: " Mobile Wallet", next: "prod_wallet" },
        { label: " LMS", next: "prod_lms" },
        { label: " Property System", next: "prod_pms" },
        { label: " POS", next: "prod_pos" },
        { label: " ERP/CRM", next: "prod_erp" },
        { label: " Clinic System", next: "prod_clinic" },
        { label: " Hotel System", next: "prod_hotel" },
        { label: " Mortgage System", next: "prod_mortgage" },
        { label: "နောက်သို့", next: "start" },
      ],
    },

    prod_wallet: {
      message:
        "သုံးစွဲသူများအတွက် User App (KYC, Top-up) နှင့် ကိုယ်စားလှယ်များအတွက် Agent App (Cash-in/out, Commission Tracking) များပါဝင်သော အဆင့်မြင့် Mobile Wallet ဂေဟစနစ်။",
      options: [{ label: "နောက်သို့", next: "products" }],
    },

    prod_lms: {
      message:
        "ကျောင်း၊ တက္ကသိုလ်များအတွက် ကျောင်းသားမှတ်တမ်း၊ ဘဏ္ဍာရေး၊ HR, စာမေးပွဲနှင့် စာကြည့်တိုက်စနစ်များ ပါဝင်သော LMS ဆော့ဖ်ဝဲလ်ဖြစ်သည်။",
      options: [{ label: "နောက်သို့", next: "products" }],
    },

    prod_pms: {
      message:
        "ကွန်ဒိုနှင့် အိမ်ခြံမြေများအတွက် အခန်းငှားရမ်းခြင်း၊ ပြုပြင်ထိန်းသိမ်းခြင်းနှင့် အသိပေးချက် (Reminders) များကို စနစ်တကျ စီမံနိုင်သော စနစ်ဖြစ်သည်။",
      options: [{ label: "နောက်သို့", next: "products" }],
    },

    prod_pos: {
      message:
        "Payment အမျိုးမျိုးကို လက်ခံနိုင်ပြီး Data များကို အချိန်နှင့်တပြေးညီ ကြည့်ရှုနိုင်သော Cloud-based POS စနစ်ဖြစ်သည်။",
      options: [{ label: "နောက်သို့", next: "products" }],
    },

    prod_erp: {
      message:
        "Customer Data များကို စုစည်းပေးပြီး အရောင်း၊ HR, ဘေလ်ပေးချေမှုနှင့် Reporting များပါဝင်သည့် ERP/CRM စနစ်ဖြစ်သည်။",
      options: [{ label: "နောက်သို့", next: "products" }],
    },

    prod_clinic: {
      message:
        "ဆေးခန်းများအတွက် Booking, ငွေတောင်းခံလွှာ၊ ဆေးဝါးလက်ကျန်နှင့် လူနာမှတ်တမ်းများကို လုံခြုံစွာ ထိန်းသိမ်းပေးသော စနစ်ဖြစ်သည်။",
      options: [{ label: "နောက်သို့", next: "products" }],
    },

    prod_hotel: {
      message:
        "ဟိုတယ်များအတွက် Booking, Check-in/out, အခန်းစီမံခန့်ခွဲမှုနှင့် ဧည့်သည်မှတ်တမ်းများအတွက် ပြည့်စုံသော စနစ်ဖြစ်သည်။",
      options: [{ label: "နောက်သို့", next: "products" }],
    },

    prod_mortgage: {
      message:
        "ချေးငွေစီမံခန့်ခွဲမှုအတွက် (Mortgage Process) Loan Application၊ Credit စစ်ဆေးခြင်းနှင့် အတိုးတွက်ချက်မှုများကို လွယ်ကူစေသော စနစ်ဖြစ်သည်။",
      options: [{ label: "နောက်သို့", next: "products" }],
    },

    ai_services: {
      message: "လုပ်ငန်းစွမ်းဆောင်ရည် မြှင့်တင်ရန် AI ဝန်ဆောင်မှုများ:",
      options: [
        { label: "AI Integration", next: "ai_integration" },
        { label: "Fine-Tuning", next: "ai_finetune" },
        { label: "နောက်သို့", next: "start" },
      ],
    },

    ai_integration: {
      message:
        "Chatbot, NLP နှင့် Image Recognition အစရှိသော AI Model များကို သင့် Application များတွင် ထည့်သွင်းပေးပါသည်။",
      options: [{ label: "နောက်သို့", next: "ai_services" }],
    },

    ai_finetune: {
      message:
        "တိကျမှုပိုမိုကောင်းမွန်စေရန် AI Model များကို သင့်လုပ်ငန်း၏ ကိုယ်ပိုင် Data များဖြင့် ပြန်လည်လေ့ကျင့် (Fine-tune) ပေးပါသည်။",
      options: [{ label: "နောက်သို့", next: "ai_services" }],
    },

    communication: {
      message: "ယုံကြည်စိတ်ချရသော ဆက်သွယ်ရေးနှင့် Payment ဝန်ဆောင်မှုများ:",
      options: [
        { label: "Cloud PBX", next: "pbx" },
        { label: "SMS Gateway", next: "sms" },
        { label: "Payment Gateway", next: "payment" },
        { label: "Top-up Gateway", next: "topup" },
        { label: "Marketing Tools", next: "marketing" },
        { label: "နောက်သို့", next: "start" },
      ],
    },

    pbx: {
      message:
        "Hardware တပ်ဆင်ရန်မလိုဘဲ Online မှတဆင့် ဖုန်းခေါ်ဆိုမှုများကို စီမံနိုင်သော Cloud PBX စနစ်ဖြစ်သည်။",
      options: [{ label: "နောက်သို့", next: "communication" }],
    },

    sms: {
      message:
        "Platform များကြားချိတ်ဆက်ပေးပြီး SMS ပို့ခြင်း၊ Delivery Tracking နှင့် Keyword Processing လုပ်ဆောင်နိုင်သော SMS Gateway ဖြစ်သည်။",
      options: [{ label: "နောက်သို့", next: "communication" }],
    },

    payment: {
      message:
        "အွန်လိုင်းမှတဆင့် လုံခြုံစွာ ငွေပေးချေနိုင်ရန် Payment Processor များနှင့် ချိတ်ဆက်ပေးသော Gateway ဖြစ်သည်။",
      options: [{ label: "နောက်သို့", next: "communication" }],
    },

    topup: {
      message:
        "မြန်မာနိုင်ငံရှိ Mobile Operator များအတွက် ဖုန်းဘေလ်ဖြည့်ခြင်း (E-Load, E-Pin) များကို တိုက်ရိုက်လုပ်ဆောင်နိုင်သော Top-up API ဝန်ဆောင်မှုဖြစ်သည်။",
      options: [{ label: "နောက်သို့", next: "communication" }],
    },

    marketing: {
      message:
        "SMS နှင့် Email မှတဆင့် Marketing Campaign များ၊ ကြေညာချက်များ ပေးပို့ရန် အထူးပြုလုပ်ထားသော Marketing Tools များဖြစ်သည်။",
      options: [{ label: "နောက်သို့", next: "communication" }],
    },

    about: {
      message:
        "Connected Group သည် မြန်မာနိုင်ငံ၏ Digital Transformation ကို အတွေ့အကြုံ ၇ နှစ်ကျော်ရှိခဲ့ပြီး အတွေ့အကြုံရှိသော လူငယ်ပညာရှင်များဖြင့် ဦးဆောင်နေပါသည်။ ICT နယ်ပယ်တွင်သာမက ပညာရေးနှင့်အခြားနယ်ပယ်များတွင်ပါ တိုးချဲ့လုပ်ကိုင်လျက်ရှိပါသည်။",
      options: [
        { label: "Mission", next: "mission" },
        { label: "Vision", next: "vision" },
        { label: "နောက်သို့", next: "start" },
      ],
    },

    mission: {
      message:
        "ယုံကြည်စိတ်ချရပြီး ဆန်းသစ်သော IT နှင့် Software ဝန်ဆောင်မှုများကို အကောင်းဆုံး ပေးအပ်ရန်။",
      options: [{ label: "နောက်သို့", next: "about" }],
    },

    vision: {
      message:
        "ခိုင်မာသော နည်းပညာအခြေခံဖြင့် Digital Solutions ဂေဟစနစ်တွင် ခေါင်းဆောင်အဖြစ် ဆက်လက်ရပ်တည်ရန်။",
      options: [{ label: "နောက်သို့", next: "about" }],
    },

    partners: {
      message:
        "ကမ္ဘာ့ထိပ်တန်း နည်းပညာကုမ္ပဏီကြီးများနှင့် ပူးပေါင်းလုပ်ကိုင်နေပါသည်။ ကျွန်ုပ်တို့၏ မိတ်ဖက်အသစ်များကိုလည်း နွေးထွေးစွာ ကြိုဆိုပါသည်။ ပူးပေါင်းလုပ်ကိုင်ရန် စိတ်ဝင်စားပါက partner@cbs.com.mm သို့ အီးမေးလ်ပေးပို့ ဆက်သွယ်နိုင်ပါသည်။",
      options: [{ label: "နောက်သို့", next: "start" }],
    },

    clients: {
      message: "အစိုးရနှင့် ပုဂ္ဂလိကလုပ်ငန်းများကို ဝန်ဆောင်မှုပေးနေပါသည်။",
      options: [
        { label: "Public", next: "c_public" },
        { label: "Private", next: "c_private" },
        { label: "နောက်သို့", next: "start" },
      ],
    },

    c_public: {
      message:
        "အစိုးရဌာနဆိုင်ရာ အဖွဲ့အစည်းများနှင့် ထိပ်တန်းတက္ကသိုလ်များစွာကို ယုံကြည်စိတ်ချစွာ ဝန်ဆောင်မှုပေးနေပါသည်။",
      options: [{ label: "နောက်သို့", next: "clients" }],
    },

    c_private: {
      message:
        "ပြည်တွင်းပြည်ပ ပုဂ္ဂလိကလုပ်ငန်းများစွာကို ဝန်ဆောင်မှုပေးနေပါသည်။",
      options: [{ label: "နောက်သို့", next: "clients" }],
    },

    locations: {
      message: "အာရှတိုက်တစ်လွှားတွင် လုပ်ငန်းများ လုပ်ကိုင်လျက်ရှိပါသည်။",
      options: [
        { label: "ဆက်သွယ်ရန်", next: "contact" },
        { label: "နောက်သို့", next: "start" },
      ],
    },

    contact: {
      message: "ဖုန်းနံပါတ်: +959 787 663 799\nအီးမေးလ်: info@connected.com.mm",
      options: [{ label: "နောက်သို့", next: "start" }],
    },

    careers: {
      message:
        "လူငယ်များနှင့် အတွေ့အကြုံရှိ ပညာရှင်များ ပေါင်းစပ်ထားသော ကျွန်ုပ်တို့အဖွဲ့တွင် ပါဝင်ရန် ဖိတ်ခေါ်ပါသည်။ အလုပ်လျှောက်ထားလိုသူများအနေဖြင့် https://forms.gle/nPdXqbjJXKXV7xon7 (သို့) hr@cbs.com.mm သို့ CV ပေးပို့ထားနိုင်ပြီး၊ လစ်လပ်နေရာ (Vacant) ရှိပါက ထည့်သွင်းစဉ်းစားပေးမည်ဖြစ်ပါသည်။",
      options: [{ label: "နောက်သို့", next: "start" }],
    },
  },
};
